
import getConfig from 'next/config';

import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { withRouter } from 'next/router';
import styled from 'styled-components';
import 'url-search-params-polyfill';
import { Footer, Header } from '@binanceus/layout';
import { ThemeProvider, lightTheme } from '@binanceus/uikit-theme';

import '../../utils/createNonce'; // for CSP
import '../../utils/polyfills'; // for old browsers


import { decimalPlaces, formatNumber } from '../../utils/number';
import { login } from '../../utils/sensors';
// import Header from '../components/Header';
import ReferralDataSetter from '../../components/ReferralDataSetter';
import { getPathWithoutLocale } from '../../utils/canonical';
import {
  verifyToken,
} from '../../actions/actionsSet/authcenter';
import { fetchUserInfo } from '../../actions/actionsSet/account';

require('../../static/css/base.css');
require('../../node_modules/react-tippy/dist/tippy.css');
require('../../node_modules/react-virtualized/styles.css');
require('../../static/css/iconfont.css');
require('../../static/css/nprogress.css');
require('../../static/css/overrides.css');

const {
  publicRuntimeConfig: {
    assetPrefix,
    brand,
    inmailWssUrl,
  },
} = getConfig();

const HTTPS = 'https://';

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: ${({
  theme, isBisicTradePage, minWidth,
}) => minWidth || (isBisicTradePage ? theme.basictTradePageMinWidth : theme.minWidth)};
  background: ${({ theme, isGreyBg }) => (isGreyBg ? theme.greyBg : theme.bg)};
  background: ${({ theme, isLoginBg }) => (isLoginBg ? theme.loginBg : '')};
  background-color: ${({ theme, isDarkBg }) => isDarkBg ? theme.referral.layoutBackgroundColor : theme.bg};
`;

const mapStateToProps = ({
  tickers,
  depthSocketConnected,
  userInfo,
  isLoggedIn,
}) => ({
  tickers,
  depthSocketConnected,
  userInfo,
  isLoggedIn,
});

const mapDispatchToProps = {
  verifyToken,
  fetchUserInfo,
};


export default
@connect(mapStateToProps, mapDispatchToProps)
@withRouter
class Layout extends Component {
  static propTypes = {
    emitAmp: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    locale: PropTypes.string,
    metaData: PropTypes.shape({
      title: PropTypes.string.isRequired,
      keywords: PropTypes.string,
      description: PropTypes.string,
      ogImage: PropTypes.string,
    }),
    omitHeader: PropTypes.bool,
    omitLangSwitch: PropTypes.bool,
    omitFooter: PropTypes.bool,
    symbol: PropTypes.string,
    both: PropTypes.array,
    tickers: PropTypes.object,
    selectedPair: PropTypes.string,
    isGreyBg: PropTypes.bool,
    isDarkBg: PropTypes.bool,
    isBisicTradePage: PropTypes.bool,
    content: PropTypes.any,
    siteLocale: PropTypes.string,
    router: PropTypes.object,
    hostName: PropTypes.string,
    depthSocketConnected: PropTypes.bool,
    userInfo: PropTypes.object,
    minWidth: PropTypes.string,
    verifyToken: PropTypes.func,
    fetchUserInfo: PropTypes.func,
  };

  static defaultProps = {
    emitAmp: false,
    isLoggedIn: false,
    locale: 'en',
    metaData: {},
    minWidth: '',
    // withTradingView: false,
    omitHeader: false,
    omitLangSwitch: false,
    omitFooter: false,
    symbol: '',
    both: ['BTC', 'USDT'], // TODO: improve.
    tickers: {},
    selectedPair: 'BTC_USDT',
    isGreyBg: false,
    isDarkBg: false,
    isBisicTradePage: false,
    content: null,
    siteLocale: 'global',
    router: { asPath: '/' },
    hostName: 'www.binance.us',
    depthSocketConnected: false,
    verifyToken: () => { },
    fetchUserInfo: () => { },
  };

  state = {
    isLoggedIn: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      isLoggedIn,
    } = prevState;
    const userId = nextProps.userInfo?.userData?.userId;
    const {
      isLoggedIn: nextIsLoggedIn,
      // eslint-disable-next-line no-shadow
      fetchUserInfo,
    } = nextProps;
    if (!isLoggedIn && nextIsLoggedIn) {
      fetchUserInfo();
    }
    if (prevState?.userId !== userId) {
      login(userId);
    }
    return {
      isLoggedIn: nextIsLoggedIn,
      userId,
    };
  }

  async componentDidMount() {
    await this.props.verifyToken();
  }


  render() {
    const {
      emitAmp,
      isLoggedIn,
      metaData,
      omitHeader,
      omitLangSwitch,
      omitFooter,
      symbol,
      both,
      tickers,
      selectedPair,
      isGreyBg,
      isDarkBg,
      isBisicTradePage,
      content,
      router,
      locale,
      hostName,
      depthSocketConnected,
      minWidth,
      userInfo,
    } = this.props;
    const canonicalUrl = `${hostName}${router.asPath}`;
    const canonicalUrlWithProtocol = !canonicalUrl.startsWith(HTTPS)
      ? `${HTTPS}${canonicalUrl}`
      : canonicalUrl;
    const ampHtmlUrl = `${hostName}/${locale}/amp${getPathWithoutLocale(router.asPath)}`;
    const ampHtmlUrlWithProtocol = !ampHtmlUrl.startsWith(HTTPS) ? `${HTTPS}${ampHtmlUrl}` : ampHtmlUrl;
    const tickSize = tickers[symbol] ? decimalPlaces(tickers[symbol].tickSize) : null;
    const tickersPrice =
      tickers[symbol] && tickers[symbol].c && tickSize && formatNumber(tickers[symbol].c, tickSize);
    const ogImage = metaData.ogImage || 'https://public.bnbstatic.us/static/images/binance_previewImage.png';
    return (
      <Fragment>
        <Head>
          <title>
            {tickersPrice && depthSocketConnected ? `${tickersPrice} | ` : ''}
            {metaData.title}
          </title>
          <link
            rel="shortcut icon"
            type="image/x-icon"
            href={`${assetPrefix}/static/images/common/favicon.ico`}
          />
          <link href={canonicalUrlWithProtocol} rel="canonical" />
          {
            emitAmp ? <link href={ampHtmlUrlWithProtocol} rel="amphtml" /> : null
          }
          {metaData.keywords ? <meta name="keywords" content={metaData.keywords} /> : null}
          <meta property="og:title" content={metaData.title} />
          <meta property="og:site_name" content={brand} />
          <meta property="og:image" content={ogImage} />
          <meta property="twitter:title" content={metaData.title} />
          <meta property="twitter:site" content={brand} />
          <meta property="twitter:image" content={ogImage} />
          <meta property="twitter:image:src" content={ogImage} />
          <meta property="twitter:card" content="summary_large_image" />
          {metaData.description ? (
            <Fragment>
              <meta name="description" content={metaData.description} />
              <meta property="og:description" content={metaData.description} />
              <meta property="twitter:description" content={metaData.description} />
            </Fragment>
          ) : null}
          {/* needed for the SSR cache, do not remove! */}
          <meta httpEquiv="X-User-Session-Validity" content={isLoggedIn ? '-SESSION_VALID-' : ''} />
        </Head>

        <StyledLayout isGreyBg={isGreyBg} isDarkBg={isDarkBg} className="layout" isBisicTradePage={isBisicTradePage} minWidth={minWidth}>
          <ReferralDataSetter />
          {!omitHeader && (
            <ThemeProvider theme={lightTheme}>
              <Header
                fixed={true}
                inmailWssUrl={inmailWssUrl}
                account={{ accountInfo: userInfo, isLoggedIn }}
              />
            </ThemeProvider>

          )}
          {content}
          {!omitFooter && (
            <Footer />
          )}
        </StyledLayout>
      </Fragment>
    );
  }
}
